import Vue from "vue";

const install = (Vue)=>{
  const Bus =new Vue({
    methods:{
      emit(event,...args){
        this.$emit(event,...args)
      },
      on(event,callback){
        this.$on(event,callback)
      },
      off(event,callback){
        this.$off(event,callback)
      }
    }
  })
  //全局事件总线
  Vue.prototype.$bus = Bus;
}
export default install



// WEBPACK FOOTER //
// ./src/vue-bus.js